import { type IGaUser } from '../../types/user/gaUser';
import { type IUser } from '../../types/user/user';

export function createGaUser(user: IUser): IGaUser {
  if (!user.isAuthenticated) {
    return { type: 'not_authorized' };
  }

  const { id: cianUserId, userType: type, tariff: tarif, balance, userId } = user;

  return {
    balance,
    cianUserId,
    tarif,
    type,
    userId,
  };
}
